import { createRouter, createWebHistory } from 'vue-router'
import OnePage from '@/views/OnePage.vue'
import DevWeb from '@/views/DevWeb.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: OnePage
  },

  {
    path: '/devweb',
    name: 'DevWeb',
    component: DevWeb
  }


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
